import keyMirror from 'keymirror';

export default keyMirror({
  SET_LOCAL_LABEL_FONT_SIZE: null,
  SET_LOCAL_LABEL_FONT_COLOR: null,
  SET_LOCAL_LABEL_FONT_WEIGHT: null,
  SET_LOCAL_LABEL_FONT_STYLE: null,
  SET_LOCAL_LABEL_STICK_TO: null,
  SET_LOCAL_LABEL_TEXT_DECORATION: null,
  SET_LOCAL_LABEL_TEXT_TRANSFORM: null,
  SET_LOCAL_STYLING: null,
  SET_LOCAL_SELECTION_COLOR: null,
  SET_STATIC_TEXT_FONT_SIZE: null,
  SET_STATIC_TEXT_FONT_FAMILY: null,
  SET_STATIC_TEXT_FONT_COLOR: null,
  SET_STATIC_TEXT_FONT_STYLE: null,
  SET_STATIC_TEXT_FONT_WEIGHT: null,
  SET_STATIC_TEXT_DECORATION: null,
  SET_STATIC_TEXT_TRANSFORM: null,
  SET_LOCAL_TEXTFIELD_BACKGROUND_COLOR: null,
  SET_LOCAL_TEXTFIELD_BORDER_COLOR: null,
  SET_LOCAL_TEXTFIELD_BORDER_RADIUS: null,
  SET_LOCAL_TEXTFIELD_BORDER_STYLE: null,
  SET_LOCAL_TEXTFIELD_BORDER_WIDTH: null,
  SET_LOCAL_TEXTFIELD_FONT_COLOR: null,
  SET_LOCAL_TEXTFIELD_FONT_SIZE: null,
  SET_LOCAL_TEXTFIELD_FONT_STYLE: null,
  SET_LOCAL_TEXTFIELD_FONT_WEIGHT: null,
  SET_LOCAL_TEXTFIELD_TEXT_DECORATION: null,
  SET_LOCAL_TEXTFIELD_TEXT_TRANSFORM: null,
  SET_QUESTION_TEXT_FONT_SIZE: null,
  SET_QUESTION_TEXT_FONT_FAMILY: null,
  SET_QUESTION_TEXT_FONT_COLOR: null,
  SET_QUESTION_TEXT_FONT_STYLE: null,
  SET_QUESTION_TEXT_FONT_WEIGHT: null,
  SET_QUESTION_TEXT_DECORATION: null,
  SET_QUESTION_TEXT_TRANSFORM: null,
  SET_OPTION_TEXT_FONT_SIZE: null,
  SET_OPTION_TEXT_FONT_FAMILY: null,
  SET_OPTION_TEXT_FONT_COLOR: null,
  SET_OPTION_TEXT_FONT_STYLE: null,
  SET_OPTION_TEXT_FONT_WEIGHT: null,
  SET_OPTION_TEXT_DECORATION: null,
  SET_OPTION_TEXT_TRANSFORM: null,
  SET_BUTTON_FONT_SIZE: null,
  SET_BUTTON_FONT_COLOR: null,
  SET_BUTTON_FONT_WEIGHT: null,
  SET_BUTTON_FONT_STYLE: null,
  SET_BUTTON_TEXT_DECORATION: null,
  SET_BUTTON_TEXT_TRANSFORM: null,
  SET_BUTTON_BORDER_WIDTH: null,
  SET_BUTTON_BORDER_STYLE: null,
  SET_BUTTON_BORDER_RADIUS: null,
  SET_BUTTON_BORDER_COLOR: null,
  SET_BUTTON_BACKGROUND_COLOR: null,
  FINISH_LOCAL_STYLING_PERSISTENCE: null,
  SET_PAGE_BACKGROUND_COLOR: null,
  SET_BODY_BACKGROUND_COLOR: null,
  SET_BODY_BACKGROUND_IMAGE: null,
  SET_BODY_BACKGROUND_POSITION: null,
  SET_BLOCK_MARGIN: null,
});
